import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../services/auth/reducer';
import { withRouter } from 'react-router';

interface ILogoutListenerProps {
  actions: {
    auth: IAuthActions;
  };
}

const LogoutListener = ({ actions, ...props }: ILogoutListenerProps) => {

  const handleLogout = () => {
    actions.auth.logout()
  };

  handleLogout();
}

export default flow([
  connect(
    (state: IStore) => {
      return {};
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
      }
    })
  ),
  withRouter,
])(LogoutListener);
